exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--app__avatar[data-v-4df339fe]{position:relative;top:-64px;margin-bottom:-32px}.v-card--app__heading[data-v-4df339fe]{top:-30px}.v-card--app__heading[data-v-4df339fe],.v-card--app__heading-2[data-v-4df339fe]{position:relative;transition:.3s ease;z-index:1}.v-card--app__heading-2[data-v-4df339fe]{top:-15px}.v-sheet[data-v-4df339fe]{border-radius:4px}", ""]);

// exports
